import React, { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { handleErrorNotification } from 'Common/utils';
import {
  useSaveSettings,
  useSettings,
  useResetSettings,
} from 'RKSV/hooks/settings';
import SettingsForm from './views/SettingsForm';

const SettingsContainer = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();
  const { isLoading, data, error } = useSettings();
  const saveSettingsMutation = useSaveSettings();
  const resetSettingsMutation = useResetSettings();
  useEffect(() => {
    if (error) {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    }
  }, [error]);

  return (
    <SettingsForm
      centerLoading
      isDataLoading={isLoading}
      data={data}
      handleSubmit={saveSettingsMutation.mutate}
      handleReset={resetSettingsMutation.mutate}
      disableFields={
        queryClient.getQueryData(['rksv', 'settings']) !== undefined &&
        !Array.isArray(queryClient.getQueryData(['rksv', 'settings']))
      }
    />
  );
};

export default SettingsContainer;
